<template>
  <div
    v-if="!record.isTotalRow"
    class="distance-cell"
    :class="{ 'distance-cell_disabled': !canEdit }"
    @click="canEdit && record.distance.value !== 0 && (isShowRoutesModal = true)"
  >
    <c-sidesheet class="distance-cell-sidesheet" :active="isShowRoutesModal" @close="closeRoutesModal">
      <svg
        class="distance-cell-sidesheet-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="closeRoutesModal"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="distance-cell-sidesheet-table">
        <div v-if="isDataLoading" class="distance-cell-sidesheet-table-loader">
          <font-awesome-icon :icon="icon" spin />
        </div>
        <c-table-data-orders
          v-if="!isDataLoading"
          ref="table"
          class="distance-cell-sidesheet-table-table"
          empty-records-label="Записи не найдены"
          :levels="1"
          :disabled-columns="tableData.disabledColumns"
          :data="tableData"
          active-tab="routes"
          @changeDriver="changeDriver"
          @recountDriver="recountDriver"
        />
      </div>
    </c-sidesheet>
    <div class="distance-cell-value">
      {{ record.distance.value == 0 ? "" : record.distance.value }}
    </div>
  </div>
  <div v-else class="distance-cell-sum-row">
    {{ record.distance.value }}
  </div>
</template>
<script>
import moment from "moment";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import DataTableOrders from "@/pages/calculations/create/additions/sidesheet-additions/data-table-orders";
import Sidesheet from "@/components/sidesheet";

export default {
  name: "delivery-distance-cell",
  components: {
    "c-sidesheet": Sidesheet,
    "c-table-data-orders": DataTableOrders,
    FontAwesomeIcon,
  },
  props: ["record", "calculationData", "calculationType", "canEdit"],
  data() {
    return {
      icon: faSpinner,
      isShowRoutesModal: false,
      isDataLoading: true,
      routesTableColumns: [
        {
          id: "route",
          label: "Маршрут",
          fullName: "Маршрут",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "start_end",
          label: "Начало/завершение",
          fullName: "Начало/завершение",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "distance",
          label: "Дистанция, км",
          fullName: "Дистанция, км",
          type: "number",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "estimated_actual_travel_time",
          label: "Расч./факт. время в пути",
          fullName: "Расч./факт. время в пути",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
      ],
      tableData: {
        type: "delivery-orders-table",
        columns: [],
        records: [],
        actions: false,
        enabledFields: [],
        levels: 1,
        disabledColumns: [],
        defaultDisabledColumns: [],
        filteredColumns: [],
        activeFilteredColumns: [],
      },
    };
  },
  watch: {
    isShowRoutesModal(value) {
      if (value) { 
        if (this.calculationType === "byPeriod") {
          this.$store
            .dispatch("calculations/getOrdersRoutesData", {
              filialId: this.calculationData.period.calculation.filialID
                ? this.calculationData.period.calculation.filialID
                : this.calculationData.period.calculation.filial_id,
              workerId: this.record.id,
              date: moment(this.calculationData.period.calculation.datetime).format("DD.MM.YYYY"),
              dateend: moment(this.calculationData.period.calculation.datetime_end).format("DD.MM.YYYY"),
            })
            .then((res) => {
              const routes = [];
              this.tableData.columns = this.routesTableColumns;
              res.routes.forEach((route) => {
                routes.push({
                  route: {
                    value: route.orders.map((order) => order.delivery.address).join("<br>"),
                  },
                  start_end: {
                    value: `${route.date} ${route.start_time}<br>` + (route.end_time!==null ? `${route.date} ${route.end_time}` : '&ndash;'),
                  },
                  distance: {
                    value: Math.round(route.distance/1000*10)/10,
                  },
                  estimated_actual_travel_time: {
                    value: this.getTimeDifference(route.start_time, route.end_time),
                  },
                });
              });

              this.tableData.records = [...routes];
              setTimeout(() => {
                this.isDataLoading = false;
              }, 500);
            });
        } else {
          
          this.$store
            .dispatch("calculations/getOrdersRoutesData", {
              filialId: this.calculationData.calc.calculation.filial_id,
              workerId: this.record.id,
              date: this.calculationData.calc.calculation.date,
            })
            .then((res) => {
              const routes = [];
              this.tableData.columns = this.routesTableColumns;
              res.routes.forEach((route) => {
                let strp = "-", strf="-";
                let p = route.plan_duration;
                if (p) {
                  strp = "";
                  let h  = Math.floor(p/3600)
                  if (h) strp = h + " ч. ";
                  let m = Math.round((p-h*3600)/60);
                  strp += (m+" мин");
                }
                p = route.duration;
                if (p) {
                  strf = "";
                  let h  = Math.floor(p/3600)
                  if (h) strf = h + " ч. ";
                  let m = Math.round((p-h*3600)/60);
                  strf += (m+" мин");
                }

                routes.push({
                  route: {
                    value: route.orders.map((order) => order.delivery.address).join("<br>"),
                  },
                  start_end: {
                    value: `${route.date} ${route.start_time}<br>` + (route.end_time!==null ? `${route.date} ${route.end_time}` : '&ndash;'),
                  },
                  distance: {
                    value: Math.round(route.distance/1000*100)/100,
                  },
                  estimated_actual_travel_time: {
                    value: strp + " / " +strf,
                  },
                });
              });

              this.tableData.records = [...routes];
              setTimeout(() => {
                this.isDataLoading = false;
              }, 500);
            });
        }
      }
    },
  },
  methods: {
    changeDriver(record)  {
      this.$emit("changeDriver", record);
    },

    recountDriver(record)  {
      this.$emit("recountDriver", this.record);
      this.$emit("close");
      setTimeout(() => {
        this.isShowOrdersModal = false;
      }, 150);
    },

    getTimeDifference(start, end) {
      const startTime = moment(start, "HH:mm");
      const endTime = moment(end, "HH:mm");

      const duration = moment.duration(endTime.diff(startTime));

      const hours = parseInt(duration.asHours(), 10);

      const minutes = parseInt(duration.asMinutes(), 10) % 60;

      if (hours > 0) return `${hours}ч ${minutes} мин`;
      return `${minutes} мин`;
    },
    closeRoutesModal() {
      this.$emit("close");
      setTimeout(() => {
        this.isShowRoutesModal = false;
      }, 150);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.distance-cell {
  &-sum-row {
    line-height: 13px;
    font-size: 13px;
    padding: 10px;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &-value {
    line-height: 13px;
    font-size: 13px;
    padding: 10px;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    color: #0066ff;
    cursor: pointer;
  }

  &-sidesheet {
    position: relative;

    ::v-deep .sidesheet__header {
      flex-basis: 0;
    }

    ::v-deep .sidesheet__wrapper {
      width: calc(100vw - 161px);
      padding: 38px 30px 38px 31px;

      @media screen and (max-width: 1024px) {
        width: calc(100vw - 62px);
      }

      @media screen and (max-width: 700px) {
        padding: 28px 20px;
        max-width: 100%;
        width: 100%;
      }
    }

    &-close {
      position: absolute;
      top: 12px;
      right: 12px;
      display: none;

      @media screen and (max-width: 700px) {
        display: block;
      }
    }

    &-table {
      width: 100%;
      height: 100%;
      margin-top: 6px;
      overflow-y: auto;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        width: 24px;
        // height: 24px;
        // height: calc(100vh - 24px);
        background: white;
        cursor: pointer;
        // box-shadow: $box-shadow-container;
        z-index: 300;
        position: relative;

        @media (max-width: 992px) {
          display: none;
        }
      }

      &::-webkit-scrollbar-thumb {
        background: $color-secondary;
        border-radius: 12px;
        background-clip: padding-box;
        border: 10px solid#fff;

        // @media (max-width: 992px) {
        //     display: none;
        // }
      }

      &::-webkit-scrollbar-track {
        background: $color-border-alt;
        width: 4px;
        background: white;
        z-index: 300;
        position: relative;

        @media (max-width: 992px) {
          display: none;
        }
      }

      &-table {
        width: 100%;

        @media screen and (max-width: 700px) {
          width: calc(100% + 41px);
        }

        &::v-deep td:before,
        &::v-deep th:before {
          background: transparent;
          border: 0 !important;
        }

        &::v-deep .c-table__cell,
        &::v-deep .c-table__column {
          position: static !important;
        }
      }

      &-loader {
        display: flex;
        font-size: 32px;
        width: 100%;
        height: 100%;
        justify-content: center;
        color: #ff238d;

        @media screen and (max-width: 700px) {
          padding-bottom: 20px;
        }
      }
    }
  }

  &_disabled {
    cursor: default;
  }
}
</style>
